/* eslint-disable jsx-a11y/anchor-is-valid */
import clsx from 'clsx'
import React, {FC} from 'react'
import {Link} from 'react-router-dom'
import {KTSVG, toAbsoluteUrl} from '../../../helpers'
import {FleksupService} from '../../../../app/services/FleksupService'
import {useDispatch, useSelector} from 'react-redux'
import {RootState} from '../../../../setup'
import * as appRedux from '../../../../app/store/app'

const notificationTypes: any = {
  Info: {
    type: 'info',
    icon: 'icons/duotune/files/fil023.svg',
  },
  Error: {
    type: 'Error',
    icon: 'icons/duotune/files/fil023.svg',
  }
}

const HeaderNotificationsMenu: FC = () => {
  const dispatch = useDispatch()

  const {data: notifications, isLoading: notificationsLoading}: any = useSelector<RootState>(
    ({app}) => app.notifications
  )
  const {data: unreadCount}: any = useSelector<RootState>(({app}) => app.notificationsCount)

  const timeSince = (date: any) => {
    // @ts-ignore
    let seconds: any = Math.floor((new Date() - new Date(date)) / 1000)
    let interval = seconds / 31536000

    if (interval > 1) {
      return Math.floor(interval) + ' yıl'
    }
    interval = seconds / 2592000
    if (interval > 1) {
      return Math.floor(interval) + ' ay'
    }
    interval = seconds / 86400
    if (interval > 1) {
      return Math.floor(interval) + ' gün'
    }
    interval = seconds / 3600
    if (interval > 1) {
      return Math.floor(interval) + ' saat'
    }
    interval = seconds / 60
    if (interval > 1) {
      return Math.floor(interval) + ' dakika'
    }
    return Math.floor(seconds) + ' saniye'
  }

  const markAsRead = async (notification: any) => {
    if (!notification.is_Read) {
      FleksupService.markAsRead([notification.id]).then((res) => {
        if (res.data.successful) {
          const clickedIndex = notifications.findIndex((item: any) => item.id === notification.id)
          notifications[clickedIndex].is_Read = true

          dispatch(appRedux.actions.getNotificationsRequestSuccess([...notifications]))

          dispatch(
            appRedux.actions.getNotificationsCountRequestSuccess(
              unreadCount - 1 === 0 ? 0 : unreadCount - 1
            )
          )
        }
      })
    }
  }

  return (
    <div
      className='menu menu-sub menu-sub-dropdown menu-column w-350px w-lg-375px'
      data-kt-menu='true'
    >
      <div
        className='d-flex flex-column bgi-no-repeat rounded-top'
        style={{backgroundImage: `url('${toAbsoluteUrl('/media/misc/pattern-1.jpg')}')`}}
      >
        <h3 className='text-white fw-bold px-9 mt-10 mb-6'>
          Bildirimler{' '}
          {unreadCount !== 0 && (
            <span className='fs-8 opacity-75 ps-3'>{unreadCount} yeni bildirim</span>
          )}
        </h3>
      </div>
      <div className='tab-content'>
        <div className='tab-pane fade show active' id='kt_topbar_notifications_1' role='tabpanel'>
          <div className='scroll-y mh-325px my-5 px-8'>
            {notificationsLoading ? (
              'Yükleniyor...'
            ) : notifications && notifications.length > 0 ? (
              notifications.map((notification: any, index: any) => (
                <div
                  key={`alert${index}`}
                  className='d-flex flex-stack py-4 position-relative cursor-pointer'
                  onClick={() => markAsRead(notification)}
                >
                  {!notification.is_Read && (
                    <span className='bullet bullet-dot bg-success h-6px w-6px position-absolute translate-middle bullet-position-top-left animation-blink'></span>
                  )}
                  <div className='d-flex align-items-center'>
                    <div className='symbol symbol-35px me-4'>
                      <span
                        className={clsx(
                          'symbol-label',
                          `bg-light-${notificationTypes[notification.type].type}`
                        )}
                      >
                        {' '}
                        <KTSVG
                          path={`/media/${notificationTypes[notification.type].icon}`}
                          className={`svg-icon-2 svg-icon-${
                            notificationTypes[notification.type].type
                          }`}
                        />
                      </span>
                    </div>
                    <div className='mb-0 me-2'>
                      <span className='fs-6 text-gray-800 text-hover-primary fw-bolder'>
                        {notification.notification_Text}
                      </span>
                    </div>
                  </div>
                  <span className='badge badge-light fs-8'>
                    {timeSince(notification.created_Date)} önce
                  </span>
                </div>
              ))
            ) : (
              <div>Henüz bildiriminiz bulunmuyor.</div>
            )}
          </div>
          {notifications && notifications.length > 0 && (
            <div className='py-3 text-center border-top'>
              <Link to='/' className='btn btn-color-gray-600 btn-active-color-primary'>
                Tüm Bildirimleri Göster
                <KTSVG path='/media/icons/duotune/arrows/arr064.svg' className='svg-icon-5' />
              </Link>
            </div>
          )}
        </div>
      </div>
    </div>
  )
}
export {HeaderNotificationsMenu}
